import clsx from "clsx";

export interface CountProps {
  count: number;
  size?: "sm" | "base" | "lg";
  bgColor?: string;
}

export function Count(props: CountProps) {
  const { count, size, bgColor = "bg-light-blue" } = props;

  const sizes = {
    sm: "w-[20px] h-[20px] text-xs",
    base: "w-[26px] h-[26px] text-sm",
    lg: "sm:w-[32px] sm:h-[32px] sm:text-sm w-[40px] h-[40px] text-base",
  };

  const expandedSizes = {
    sm: "w-[28px] h-[28px]",
    base: "w-[38px] h-[36px]",
    lg: "sm:w-[38px] sm:h-[36px] w-[52px] h-[50px]",
  };

  if (count <= 0) {
    return null; // Return nothing if count is 0 or less
  }

  return (
    <div
      className={clsx(
        "flex items-center justify-center rounded-full text-gray-extra-dark font-medium",
        size && (count > 99 ? expandedSizes[size] : sizes[size]),
        bgColor
      )}
    >
      {count}
    </div>
  );
}

export default Count;
